import { render, staticRenderFns } from "./PageAlerts.vue?vue&type=template&id=f13e36d8&scoped=true"
import script from "./PageAlerts.vue?vue&type=script&lang=js"
export * from "./PageAlerts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f13e36d8",
  null
  
)

export default component.exports